import React from "react";
import PropTypes from "prop-types";
import { Drawer } from "@mui/material";
import styles from "./variantDrawerDesktop.scss";
import NewSpinner from "../newSpinner/newSpinner";
import FallbackImg from "../../assets/images/fallbackImg.png";

export default function VariantDrawerDesktop(props) {
  const {
    open,
    onClose,
    productInfo,
    renderVariants,
    renderFooter,
    renderAdditionalInfo,
    productStatus,
    isLoadingVariant,
  } = props;

  const intlNumberFormatter = new Intl.NumberFormat("en-US");
  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={open}
      ModalProps={{ onBackdropClick: onClose }}
      classes={{
        paper: styles["drawer-wrapper"],
        modal: styles["drawer-backdrop"],
      }}
    >
      <div className={styles["drawer-container"]}>
        <button className={styles["close-btn"]} onClick={onClose}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.3478 7.9752L15.717 2.60598C16.0275 2.29545 16.0275 1.79153 15.717 1.4805L14.4694 0.232897C14.1589 -0.0776324 13.6549 -0.0776324 13.3439 0.232897L7.97519 5.60262L2.60597 0.233396C2.29544 -0.077134 1.79152 -0.077134 1.48049 0.233396L0.233385 1.4805C-0.0771441 1.79103 -0.0771441 2.29495 0.233385 2.60598L5.60261 7.9752L0.233385 13.3444C-0.0771441 13.655 -0.0771441 14.1589 0.233385 14.4699L1.48099 15.7175C1.79152 16.028 2.29544 16.028 2.60647 15.7175L7.97519 10.3478L13.3444 15.717C13.6549 16.0275 14.1589 16.0275 14.4699 15.717L15.7175 14.4694C16.028 14.1589 16.028 13.655 15.7175 13.3439L10.3478 7.9752Z"
              fill="#2C2C2C"
            />
          </svg>
        </button>
        {productInfo ? (
          <>
            <div className={styles["content"]}>
              <div className={styles["product-info"]}>
                {!isLoadingVariant && productInfo ? (
                  <>
                    <div className={styles["image"]}>
                      {productInfo?.image ? (
                        <img
                          src={productInfo?.image}
                          alt={productInfo.productName}
                        />
                      ) : (
                        <img
                          style={{ objectFit: "contain", width: "70%" }}
                          src={FallbackImg}
                          alt=""
                        />
                      )}
                    </div>
                    <div className={styles["details"]}>
                      <div className={styles["brand"]}>
                        {productInfo.productBrand ? productInfo.productBrand : "-"}
                      </div>
                      <div className={styles["name-prices"]}>
                        <div className={styles["name"]}>
                          {productInfo?.productName}
                        </div>

                        <div className={styles["prices"]}>
                          <div className={styles["price"]} translate="no">
                            {"$" +
                              " " +
                              intlNumberFormatter.format(
                                Number(productInfo?.price)
                              )}
                          </div>
                          {productStatus ? (
                            <span
                              className={styles["status"]}
                              style={{ color: productStatus?.colorCode }}
                            >
                              {productStatus?.label}
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div style={{ margin: "17px 0px", width: "100%" }}>
                    <NewSpinner />
                  </div>
                )}
              </div>
              <div className={styles["variants-container"]}>
                {renderVariants()}
              </div>
            </div>
            {productInfo?.isOutOfStock && (
              <div className={styles["out-of-stock-text"]}>暫停供貨</div>
            )}
            {renderAdditionalInfo && (
              <div className={styles["additional-info"]}>
                {renderAdditionalInfo}
              </div>
            )}
            {renderFooter && (
              <div className={styles["footer"]}>{renderFooter()}</div>
            )}
          </>
        ) : (
          <div style={{ margin: "100px 0px" }}>
            <NewSpinner size="md" />
          </div>
        )}
      </div>
    </Drawer>
  );
}

VariantDrawerDesktop.defaultProps = {
  open: false,
  onClose: () => { },
  productInfo: null,
  renderVariants: () => { },
  renderFooter: () => { },
};
VariantDrawerDesktop.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  productInfo: PropTypes.object,
  renderVariants: PropTypes.func,
  renderFooter: PropTypes.func,
};
